import React from 'react'
import { Container, Card } from '@jsluna/react'
import { PropTypes } from 'prop-types'
import FireRollCallGrid from './FireRollCallGrid'
import SiteSearch from '../SiteSearch'
import SiteList from './../../components/SiteList'
import { getLocalDateTime } from './../../utils/timer'

class FireRollCall extends React.Component {
  constructor() {
    super()
    this.state = {
      selected: new Map(),
      personCount: 0
    }
    this.toggleSelect = this.toggleSelect.bind(this)
    this.peopleCount = this.peopleCount.bind(this)
  }

  componentWillMount() {
    this.props.initialiseSites()
    if (this.props.setMenu === true) {
      this.props.setMenuSelectedState({ selectedMenu: '/firerollcall' })
    }
  }

  componentWillReceiveProps() {
    this.setState({ personCount: 0 })
  }

  toggleSelect(checked) {
    if (checked) {
      this.setState({ personCount: this.state.personCount + 1 })
    } else {
      this.setState({ personCount: this.state.personCount - 1 })
    }
  }

  peopleCount(fireRollCallLength, currentSiteName) {
    if (fireRollCallLength > 0) {
      return (<span className="ln-u-font-family-brand ln-u-font-size-h3 ln-u-font-weight-medium">
        {`${this.state.personCount} / ${this.props.fireRollCall.fireRollCallList.length} people checked`}</span>)
    }
    if (currentSiteName) {
      return <span className="ln-u-font-family-brand ln-u-font-size-h4 ln-u-font-weight-regular">{'There were no contractors signed in at the last updated time'}</span>
    }
    return ''
  }

  render() {
    const currentSiteName = this.props.currentSite.other_name
    const siteType = this.props.currentSite.sitetype
    const fireRollCall = this.props.fireRollCall
    const fireRollCallLength = this.props.fireRollCall.fireRollCallList !== undefined ? this.props.fireRollCall.fireRollCallList.length : 0
    return (
      <div className="ln-c-header-body ln-u-soft-top" id="main-content">
        <Container soft>
          <Container soft>
            <h3 style={{ marginLeft: '55px' }}>{'Who\'s on site'}</h3>
          </Container>
          <Card className="card">
            <h5>
              Select a site
            </h5>
            <div className="c-site-search">
              <SiteSearch />
              <div className="c-site-search-list">
                <SiteList />
              </div>
            </div>
            {this.props.isSiteSearchSuggestionsVisible ?
              '' :
              <div>
                <div><h1>{currentSiteName ? `${currentSiteName} (${siteType})` : ''}</h1></div>
                <div className="ln-o-grid">
                  <div className="ln-o-grid__item ln-u-1/1 ln-u-1/2@md">
                    {this.peopleCount(fireRollCallLength, currentSiteName)}
                  </div>
                  <div className="ln-o-grid__item ln-u-1/1 ln-u-1/2@md u-right-align-md">
                    {currentSiteName.length > 0 ?
                      <span className="ln-u-font-family-brand"><span className="ln-u-font-size-h5 ln-u-font-weight-bold">Last updated </span>
                        <span className="ln-u-font-size-h5 ln-u-font-weight-regular">{getLocalDateTime(fireRollCall.refreshDateTime)}
                        </span>
                      </span> : ''}
                  </div>
                </div>
                <div>
                  {(fireRollCallLength > 0 ?
                    <FireRollCallGrid fireRollCallData={fireRollCall.fireRollCallList} handleCheckboxChange={checked => this.toggleSelect(checked)} />
                    : ''
                  )}
                </div>
              </div>
            }
          </Card>
        </Container>
      </div>
    )
  }
}

FireRollCall.propTypes = {
  currentSite: PropTypes.shape({
    other_name: PropTypes.string.isRequired,
    sitetype: PropTypes.string.isRequired
  }).isRequired,
  fireRollCall: PropTypes.shape({
    fireRollCallList: PropTypes.array.isRequired,
    refreshDateTime: PropTypes.string.isRequired
  }).isRequired,
  initialiseSites: PropTypes.func.isRequired,
  setMenu: PropTypes.bool.isRequired,
  setMenuSelectedState: PropTypes.func.isRequired,
  isSiteSearchSuggestionsVisible: PropTypes.bool.isRequired

}

FireRollCall.defaultProps = {
  isSiteSearchSuggestionsVisible: true
}

export default FireRollCall



// WEBPACK FOOTER //
// ./src/components/FireRollCall/FireRollCall.jsx